const serviceAreas = {
  serviceAreas: {
    pageHeader: 'Servicebereiche',
    description:
      'Wenn ein Hausbesitzer in einer bestimmten Gegend nach Enphase Installateuren sucht, verwenden wir das von Ihnen hier eingegebene %{regionOrCountyLabel}, um zu prüfen, ob Sie in dieser Gegend für Dienstleistungen zur Verfügung stehen oder nicht.',
    addNewArea: 'Neuen Bereich hinzufügen',
    new: 'Neu',
    areaName: 'Bereichsbezeichnung',
    servicesCovered: {
      countiesCovered: 'Abgedeckte Landkreise',
      regionsCovered: 'Abgedeckte Regionen',
      regionsWithCount: 'Abgedeckte %{region} (die ersten %{typeCharacters} Stellen der PLZ)',
      districtsCovered: 'Abgedeckte Bezirke',
      citiesCovered: 'Abgedeckte Gemeinden',
      citiesCoveredbr: 'Städte Gemeinden',
      departments: 'abteilungen',
      regions: 'Regionen',
      counties: 'Landkreise',
      districts: 'Bezirke',
      cities: 'gemeinden',
      city: 'städte'
    },
    selectAllCounty: 'Alle %{regionOrCountyLabel} eines bestimmten Bundeslandes auswählen',
    selectAllDepartment: 'Alle Abteilungen auswählen',
    addCountiesRegionsButton: '%{regionOrCountyLabel} hinzufügen',
    countyButtonDescription:
      'Anhand der von Ihnen ausgewählten Bundesländer werden alle entsprechenden %{regionOrCountyLabel} hinzugefügt',
    area1: 'BEREICH 1',
    selectState: 'Bundesland auswählen',
    requestNotProcessed: 'Die Anfrage konnte nicht verarbeitet werden.',
    footerTitle:
      'Die Richtpreise sollten die Kosten für die Installation, das Gestell, das PV-Modul, den Wechselrichter usw. beinhalten. Kosten für die Dachdeckung und das Upgrade des Hauptverteilers bspw. können dazu kommen.',
    footerBody:
      'Enphase stellt dem Hausbesitzer diese Richtpreise zur Verfügung. Enphase weist den Hausbesitzer darauf hin, dass es sich dabei um unverbindliche Preise handelt, bei denen Änderungen vorbehalten sind.',
    noBlankRegions: 'Die abgedeckten %{regionOrCountyLabel} dürfen nicht leer bleiben.',
    //noBlankCounties: 'Die abgedeckten Landkreise dürfen nicht leer bleiben.',
    deleteConfirmation: 'Möchten Sie diesen Servicebereich wirklich löschen?',
    ok: 'OK',
    infoText: `%{bTagOpen}Region%{bTagClose} ist definiert als die ersten %{count} Ziffern einer Postleitzahl eines %{stateOrProvince}`,
    infoTextFr: `Abteilung ist definiert als die ersten 2 Ziffern der Postleitzahl`,
    state: 'Staat',
    province: 'Provinz',
    noOptions: 'Keine Optionen'
  }
};

export default serviceAreas;
